import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SeatFileFidelizationProductsCupraModel } from '../models/SeatFileFidelizationProductsCupra';
import { CupraBudgetModel } from '../models/cuprabudget';


@Injectable({
  providedIn: 'root'
})

export class BudgetBuilderService {

  private pathAPI = environment.urlAPI;
  private controller = "BudgetBuilder/";

  constructor(private http: HttpClient) { }

  public SearchbyMatricula(data: string): Observable<SeatFileFidelizationProductsCupraModel> {
    return this.http.get<SeatFileFidelizationProductsCupraModel>(this.pathAPI + this.controller + 'SearchTmaimg?matricula=' + data);
  }
  public SearchbyBastidor(data: string): Observable<SeatFileFidelizationProductsCupraModel> {
    return this.http.get<SeatFileFidelizationProductsCupraModel>(this.pathAPI + this.controller + 'SearchTmaimg?bastidor=' + data);
  }

}
